import { bootstrapApplication } from '@angular/platform-browser';
import { applyCachedBrand, clearBrand } from '@crewdle/white-label';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// Kill the flash of default branding on a returning partner-branded session:
// synchronously re-applies the last-known brand from localStorage before
// Angular even bootstraps. The live Firestore read in WhiteLabelService then
// confirms or replaces it.
//
// A wrong-shaped cache entry (e.g. a stale/cross-version format — this
// localStorage key is shared across Crewdle apps on the same origin family)
// throws inside the package's brand application (reads into `colors` with no
// shape validation). Uncaught, that stops this module before
// `bootstrapApplication` ever runs — the splash never clears, and the bad
// entry is never cleared either, so every subsequent load fails identically.
// `clearBrand()` wipes the cache so the next load starts clean;
// `WhiteLabelService`'s live Firestore read repopulates it with a well-shaped
// entry.
try {
  applyCachedBrand();
} catch (err) {
  console.error('Failed to apply cached white-label brand; clearing cache.', err);
  clearBrand();
}
// The package's complete cached-brand stylesheet now supersedes the tiny
// parser-time stylesheet. Removing it also lets clearBrand() fully restore
// defaults if the live hostname/org lookup rejects a stale cache.
document.getElementById('crewdle-white-label-prepaint')?.remove();

bootstrapApplication(App, appConfig)
  .then(() => document.getElementById('splash-screen')?.remove())
  .catch((err) => console.error(err));
